<div class="thread-view" [ngClass]="themeClass">
  <!-- These toolbars pop outside of this card in mobile -->
  <mat-toolbar
    [ngClass]="{
      'mobile-thread-top-nav': !newThread,
      'mobile-error': threadError
    }"
    class="position-toolbar mobile-visible"
    color="primary"
  >
    <ng-container *ngIf="!newThread">
      <div class="title-users" (click)="clickMobileHeader()">
        <div *ngIf="mode === 'task'" class="mode-indicator">
          <mat-icon>check</mat-icon> Task in {{ spaceName }} space:
        </div>
        <div *ngIf="mode === 'thread'" class="mode-indicator">
          <mat-icon>chat_bubble</mat-icon> Thread:
        </div>
        <div *ngIf="mode === 'channel'" class="mode-indicator">
          <mat-icon>chat_bubble</mat-icon> Channel:
        </div>
        <div *ngIf="mode === 'space'" class="mode-indicator">
          <mat-icon>chat_bubble</mat-icon> Space channel:
        </div>
        <div *ngIf="mode === 'direct'" class="mode-indicator">
          <mat-icon>chat_bubble</mat-icon> Direct message:
        </div>
        <div *ngIf="mode === 'announcement'" class="mode-indicator">
          <mat-icon>chat_bubble</mat-icon> Announcement:
        </div>
        <div class="title">{{ threadData.title }}</div>
        <div class="users">
          <span *ngFor="let userEle of threadData.currentUserArray">
            {{ userEle.user.name }}
          </span>
        </div>
      </div>

      <button
        mat-icon-button
        class="menu-button highlight-on-mouseover"
        [matMenuTriggerFor]="menu"
        aria-label="Menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </ng-container>

    <ng-container *ngIf="threadError">
      <span *ngIf="threadError === 'threadNotFound'">
        Message: Thread not found.
      </span>
      <span *ngIf="threadError === 'userNotFound'">
        Message: User not found.
      </span>
    </ng-container>
  </mat-toolbar>
  <mat-toolbar class="hidden-positioner-toolbar mobile-visible"> </mat-toolbar>

  <ng-container *ngIf="threadError">
    <span *ngIf="threadError === 'noSelectedUser'">
      There was a problem with your login.
      <a href="#" (click)="reloadPage()">Click here to reload. </a>
    </span>
    <span *ngIf="threadError === 'threadNotFound'">Thread not found. </span>
    <span *ngIf="threadError === 'userNotFound'">User not found. </span>
    <a [routerLink]="inboxLink" class="mobile-visible text-link">
      Back to messages.
    </a>
  </ng-container>

  <div *ngIf="newThread" class="new-thread-top desktop-thread-top-spacing">
    <div>{{ newThread.mode === 'channel' ? 'New channel' : 'New thread' }}</div>

    <mat-form-field class="new-title-form-field">
      <mat-label>{{
        newThread.mode === 'channel' ? 'Channel name' : 'Thread title'
      }}</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        [formControl]="titleFormControl"
        [placeholder]="
          newThread.mode === 'channel' ? 'Channel name' : 'Thread title'
        "
        class="new-title-textarea"
        rows="1"
      ></textarea>
    </mat-form-field>
    <app-thread-recipient-editor-new
      [orgId]="orgId"
      [userId]="userId"
      [submitAttempted]="newThread.submitAttempted"
      (userIdsOutput)="handleUserIdsNewThread($event)"
    ></app-thread-recipient-editor-new>

    <mat-error *ngIf="this.newThread.userIds.length === 0 && this.canSend">
      You are the only user in this thread.
    </mat-error>
  </div>

  <div
    *ngIf="!newThread"
    class="thread-top desktop-thread-top-spacing desktop-visible"
  >
    <div>
      <div *ngIf="mode !== 'task'" class="thread-title-menu-button">
        <div class="thread-title">
          {{ threadData.title }}
        </div>
        <div>
          <button
            mat-icon-button
            class="menu-button highlight-on-mouseover"
            [matMenuTriggerFor]="menu"
            aria-label="Menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="mode === 'task'" class="task-title-menu-button">
        <div class="discussion-head-text task-detail-sub-header-text-style">
          Discussion
        </div>
        <div>
          <button
            mat-icon-button
            class="menu-button highlight-on-mouseover"
            [matMenuTriggerFor]="menu"
            aria-label="Menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>

      <div class="user-padding">
        <button
          class="users dark-text-color"
          (click)="launchRecipientsDialog()"
        >
          <mat-icon
            *ngIf="
              mode !== 'space' &&
              mode !== 'channel' &&
              threadData.currentUserArray.length
            "
            class="material-icons-outlined"
            matTooltip="These users are notified in their inbox when new replies are made"
            aria-label="Notifications"
            >notifications</mat-icon
          >
          <mat-icon
            *ngIf="mode === 'channel'"
            class="material-icons-outlined"
            matTooltip="These users can see this discussion but are not notified in their inbox when new replies are made"
            aria-label="Visibility"
            >visibility</mat-icon
          >
          <div class="users-text">
            <span
              *ngIf="threadData.currentUserArray.length"
              [matTooltip]="
                mode !== 'space' && mode !== 'channel'
                  ? 'These users are notified in their inbox when new replies are made'
                  : 'These users can see this discussion but are not notified in their inbox when new replies are made'
              "
            >
              <span
                *ngFor="
                  let userObj of threadData.currentUserArray;
                  last as isLast;
                  index as i
                "
              >
                {{
                  userObj.user._id === userId
                    ? i === 0
                      ? 'You'
                      : 'you'
                    : userObj.user.name
                }}{{ !isLast ? ',' : '.' }}
              </span>
            </span>
            <ng-container *ngIf="mode === 'task'">
              <mat-icon class="material-icons-outlined" aria-label="Visibility"
                >visibility</mat-icon
              >
              <span class="task-thread-visibility-section">
                Visible to this task's space.</span
              >
            </ng-container>
            <ng-container *ngIf="mode === 'space'">
              <mat-icon class="material-icons-outlined" aria-label="Visibility"
                >visibility</mat-icon
              >
              <span class="task-thread-visibility-section">
                Visible to users in this space.</span
              >
            </ng-container>
          </div>
        </button>
      </div>

      <div class="divider"></div>
    </div>

    <div class="show-in-task-narrow-mode">
      <button
        mat-icon-button
        class="menu-button highlight-on-mouseover"
        [matMenuTriggerFor]="menu"
        aria-label="Menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </div>

  <div
    #messageContainer
    class="all-messages narrow-scrollbar"
    [style.padding-bottom]="messageInputPaddingHeight"
  >
    <!-- Display updates here only if no messages sent, otherwise show below initialUpdates section above message[0] -->
    <ng-container
      *ngIf="initialTaskUserUpdates && displayMessages.length === 0"
    >
      <ng-container *ngFor="let update of initialTaskUserUpdates">
        <app-thread-user-update-display
          [orgId]="orgId"
          [update]="update"
        ></app-thread-user-update-display>
      </ng-container>
    </ng-container>
    <div #messageTopDiv style="display: flex; justify-content: center">
      <mat-progress-spinner
        *ngIf="loadingMessages"
        color="primary"
        mode="indeterminate"
        diameter="20"
      >
      </mat-progress-spinner>
    </div>
    <ng-container *ngFor="let displayMessage of displayMessages">
      <ng-container
        *ngIf="initialTaskUserUpdates && displayMessage.message?.number === 0"
      >
        <ng-container *ngFor="let update of initialTaskUserUpdates">
          <app-thread-user-update-display
            [orgId]="orgId"
            [update]="update"
          ></app-thread-user-update-display>
        </ng-container>
      </ng-container>
      <app-thread-message
        id="{{ displayMessage.divId }}"
        [threadItem]="threadItem"
        [displayMessage]="displayMessage"
        [messageSeensReplaySubject]="messageSeensReplaySubject"
        [isGroup]="isGroup"
      >
      </app-thread-message>
    </ng-container>

    <div #endOfThread class="br-hack-height">
      <!-- Below <br> is to prevent scrollbars from appearing see https://stackoverflow.com/a/12877147/1275985  -->
      <br />
    </div>
  </div>

  <div class="typing-users">
    <div class="typing-users-text">
      <ng-container *ngFor="let typingUser of typingUsers; last as isLast">
        <span> {{ typingUser.name }} <span *ngIf="!isLast">, </span> </span>
      </ng-container>
      <span *ngIf="typingUsers.length">
        &nbsp;is typing
        <i class="dot1"></i><i class="dot2"></i><i class="dot3"></i>
      </span>
    </div>
  </div>

  <div
    #messageInput
    class="message-input"
    [ngClass]="{ 'textarea-focused': textareaFocused }"
    *ngIf="!(newThread && newThread.mode === 'channel')"
  >
    <div class="message-input-border">
      <div id="imageDummy" #imageDummy class="image-dummy"></div>
      <div class="message-input-left">
        <div>
          <!-- Add mat-chips -->
          <app-thread-file-upload-display
            *ngFor="let displayFile of displayFiles"
            [displayFile]="displayFile"
          >
          </app-thread-file-upload-display>
        </div>
        <textarea
          matInput
          cdkTextareaAutosize
          #messageBox
          class="message-textarea narrow-scrollbar"
          type="text"
          [placeholder]="placeHolderText"
          [formControl]="messageFormControl"
          (keydown)="submitOnEnter($event)"
          (focus)="onTextareaFocus()"
          (blur)="onTextareaBlur($event)"
        ></textarea>
      </div>
      <div class="message-input-right">
        <button
          *ngIf="false"
          mat-icon-button
          [disabled]="disableMessageInput"
          (click)="uploadFile()"
        >
          <mat-icon> attachment </mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="!canSend || disableMessageInput"
          (click)="sendMessage()"
        >
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Creating a new channel -->
  <div
    *ngIf="newThread && newThread.mode === 'channel'"
    class="create-channel-button-div"
  >
    <div></div>
    <button mat-raised-button color="primary" (click)="createChannel()">
      Create channel
    </button>
    <div></div>
  </div>
</div>

<ng-template #deleteThreadDialog>
  <mat-dialog-content>
    <div>Are you sure you want to delete this thread? <br /></div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button (click)="closeDeleteThread()" mat-raised-button color="warn">
      Cancel
    </button>
    <button
      (click)="deleteThread()"
      mat-raised-button
      cdkFocusInitial
      color="primary"
    >
      Yes
    </button>
  </mat-dialog-actions>
</ng-template>

<mat-menu #menu="matMenu">
  <button
    *ngIf="mode === 'thread' || mode === 'channel' || mode === 'announcement'"
    mat-menu-item
    (click)="launchRecipientsDialog()"
  >
    <mat-icon>manage_accounts</mat-icon>
    <span>Add/remove recipients</span>
  </button>

  <button
    *ngIf="mode === 'thread' || mode === 'channel' || mode === 'announcement'"
    mat-menu-item
    (click)="launchEditTitleDialog()"
  >
    <mat-icon>abc</mat-icon>
    <span>Change title</span>
  </button>
</mat-menu>
